import AvatarMark from './avatar-mark';

export default AvatarMark;
